import { ReactElement } from 'react';
import { ReportStatus } from 'src/features/reports/types';

export type WebSocketsContextTypes = {
  messages: any;
  alarmMessage: AlarmReadingType | null;
  reportMessage: any;
  reportNotificationIds: Set<string>;
  addReportNotificationId: (value: string) => void;
  assetStateMessages: any;
};

export type ReadingType = {
  messageType: string;
  data: [data: object];
};

export type AlarmReadingType = {
  messageType: string;
  data: {
    alarm: object;
    totalCount: {
      total: number;
      active: number;
      cleared: number;
      unacknowledged: number;
      acknowledged: number;
    };
  };
};
export type ReportMessageType = {
  messageType: string;
  data: {
    actor: any; // specify type here
    details: string;
    id: string;
    reportType: string;
    name: string;
    status: ReportStatus;
    templateId: string;
    s3Key: string;
  };
};

export type WebSocketsProviderTypes = {
  children: ReactElement;
  templateId?: string;
};

export type AssetStateMessageType = {};

export const NEW_READING_TYPE = 'NEW_READING';
export const ALARM_CHANGE_TYPE = 'ACTIVE_ALARM_CHANGE';
export const ALARM_CLEARED_EVENT = 'ALARM_CLEARED_EVENT';
export const ASSET_STATE_CHANGED_EVENT = 'ASSET_STATE_CHANGED_EVENT';
